var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"alt-badge",attrs:{"id":_vm.id,"variant":_vm.variant},on:{"click":_vm.click}},[_vm._t("default"),_vm._v("   ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }